import React, {createContext, useCallback, useContext, useEffect, useMemo, useState} from 'react';
import useResult from "../hooks/useResult";
import useTrends from "../hooks/useTrends";
import {getUrlParam} from "../constants/helpers";
import {CLIENT_HOST} from "../constants/constants";
import {ThemeContext} from "./ThemeContext";
import ReactGA from "react-ga";

export const SearchContext = createContext({});
export const SearchContextProvider = ({ children, props }) => {
  
  const [query, setQuery] = useState( '')
  const [debounceQuery, setDebounceQuery] = useState('');
  const [companyCountryPhone, setCompanyCountryPhone] = useState('+1');
  
  
  const [page, setPage] = useState( 0);
  const [rowsPerPage, setRowsPerPage] = useState( 10);
  const [type, setType] = useState( '');
  const [locale, setLocale] = useState('en')
  const [filterExplicit, setFilterExplicit] = useState( true);
  const [timeRange, setTimeRange] = useState( 'any')
  const oneMonthAgo = useMemo(()=>{
       let d = new Date();
       d.setMonth(d.getMonth() - 1);
       return d.toISOString().substring(0,10);
  }
  ,[]);
  const [timeRangeCustomStart, setTimeRangeCustomStart] = useState(oneMonthAgo)
  const [timeRangeCustomEnd, setTimeRangeCustomEnd] = useState(new Date().toISOString().substring(0,10))
  const [indexCount, setIndexCount] = useState(0)
  const [entityCount, setEntityCount] = useState(0)
  const [trendingList, setTrendingList] = useState([])
  const [searchResults, setSearchResults] = useState(null)
  const [totalSearchResults, setTotalSearchResults] = useState(-1)
  const [showExtendedCategories, setShowExtendedCategories] = useState( false)
  const originalPageTitle = useMemo(()=>document.title,[])
  const { darkMode } = useContext(ThemeContext);
  const directLink = useMemo(()=>{
    if(timeRange==='custom'){
      return `${CLIENT_HOST}/?q=${debounceQuery}&t=${darkMode ? 'dark' : 'light'}`
    }else{
      return `${CLIENT_HOST}/?q=${debounceQuery}&t=${darkMode ? 'dark' : 'light'}`
    }
     },[debounceQuery,type,page,rowsPerPage,locale,timeRange,timeRangeCustomStart,timeRangeCustomEnd,filterExplicit,showExtendedCategories,darkMode])
  
  //onload, over-ride defaults
  
  useEffect(() => {
    if (!window.location.hostname.includes("localhost")) { /* Production Only */
      const adjustedURL = directLink.split(/\.io\/?|\.dev\/?/);
      ReactGA.initialize('UA-154880-13');
      ReactGA.pageview(adjustedURL[1]);
    }
  },[directLink])
  useEffect(() => {
    if(getUrlParam('q')){
      setQuery(getUrlParam('q'))
    }
    if(getUrlParam('s')){
      setRowsPerPage(Number(getUrlParam('s')))
    }
    if(getUrlParam('p')){
      setPage(Number(getUrlParam('p')))
    }
    if(getUrlParam('c')){
      setType(getUrlParam('c'))
    }
    if(getUrlParam('l')){
      setLocale(getUrlParam('l'))
    }
    if(getUrlParam('m')){
      setFilterExplicit(Boolean(getUrlParam('m')))
    }
    if(getUrlParam('r')){
      setTimeRange(getUrlParam('r'))
    }
    if(getUrlParam('x') && getUrlParam('x') === '1'){
      setShowExtendedCategories(true)
    }
    if(getUrlParam('b')){
      setTimeRangeCustomStart(getUrlParam('b'))
    }
    if(getUrlParam('e')){
      setTimeRangeCustomEnd(getUrlParam('e'))
    }
    
  }, [setQuery, setRowsPerPage,setPage,setType,setLocale,setFilterExplicit,setTimeRange,setShowExtendedCategories,setTimeRangeCustomStart,setTimeRangeCustomEnd]);
  
  
  
  
  useEffect(() => {
    const timeOutId = setTimeout(() => {
      setDebounceQuery(query);
        document.title = debounceQuery ?  debounceQuery + " - PhoneLookup.io" : originalPageTitle
    }, 1000);
    
    return () => {
      clearTimeout(timeOutId);
    };
  }, [query, originalPageTitle]);
  
  const trendData = []
  const trendsLoading = false
  //const { data: trendData, isLoading: trendsLoading } = useTrends();
  const { data: searchResultsObj, isLoading: resultsLoading } = useResult(debounceQuery, companyCountryPhone);
  
  useEffect(() => {
   if(searchResultsObj){
     setSearchResults(searchResultsObj)
   }
  }, [searchResultsObj, resultsLoading]);
  
  useEffect(() => {
   if(trendData){
     setIndexCount(trendData.indexCount)
     setEntityCount(trendData.entityCount)
     setTrendingList(trendData.data)
   }
  }, [trendData]);
  
  const forceSearch = useCallback(value => {
    setDebounceQuery(query);
  },[query]);
  
  return (
    <SearchContext.Provider
      value={{
        actions: {
          setQuery,
          setTimeRange,
          setLocale,
          setFilterExplicit,
          forceSearch,
          setTrendingList,
          setPage,
          setType,
          setRowsPerPage,
          setTimeRangeCustomStart,
          setTimeRangeCustomEnd,
          setShowExtendedCategories,
          setCompanyCountryPhone,
        },
        state: {
          query,
          debounceQuery,
          timeRange,
          locale,
          filterExplicit,
          timeRangeCustomStart,
          timeRangeCustomEnd,
          trendingList,
          searchResults,
          totalSearchResults,
          resultsLoading,
          trendsLoading,
          indexCount,
          entityCount,
          page,
          type,
          rowsPerPage,
          directLink,
          showExtendedCategories,
          companyCountryPhone
        },
      }}
      {...props}
    >
      {children}
    </SearchContext.Provider>
  );
};
